import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api/axios';

const COMPANY = {
  name: 'TYCHE ABODES PRIVATE LIMITED',
  address: 'No. 401, Ramani\'s Frazer Square, Near Head Post Office,\nGoods Shed Road, Coimbatore - 641001.',
  gstin: '33AAKCT5967G1ZY',
  state: 'Tamil Nadu',
  stateCode: '33',
};

const inr = v => `₹${Number(v||0).toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}`;
const numToWords = n => {
  const ones=['','One','Two','Three','Four','Five','Six','Seven','Eight','Nine','Ten','Eleven','Twelve','Thirteen','Fourteen','Fifteen','Sixteen','Seventeen','Eighteen','Nineteen'];
  const tens=['','','Twenty','Thirty','Forty','Fifty','Sixty','Seventy','Eighty','Ninety'];
  if(n===0) return 'Zero';
  const convert = num => {
    if(num<20) return ones[num];
    if(num<100) return tens[Math.floor(num/10)]+(num%10?' '+ones[num%10]:'');
    if(num<1000) return ones[Math.floor(num/100)]+' Hundred'+(num%100?' '+convert(num%100):'');
    if(num<100000) return convert(Math.floor(num/1000))+' Thousand'+(num%1000?' '+convert(num%1000):'');
    if(num<10000000) return convert(Math.floor(num/100000))+' Lakh'+(num%100000?' '+convert(num%100000):'');
    return convert(Math.floor(num/10000000))+' Crore'+(num%10000000?' '+convert(num%10000000):'');
  };
  const [whole, dec] = n.toFixed(2).split('.');
  let result = convert(parseInt(whole))+' Rupees';
  if(parseInt(dec)>0) result += ' and '+convert(parseInt(dec))+' Paise';
  return result+' Only';
};

export default function SalesInvoice() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [order, setOrder]     = useState(null);
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);
  const printRef = useRef();

  useEffect(()=>{
    api.get(`/sales/orders/${id}/`).then(async r=>{
      const o = r.data.data||r.data;
      setOrder(o);
      const cr = await api.get(`/sales/customers/${o.customer}/`);
      setCustomer(cr.data.data||cr.data);
    }).finally(()=>setLoading(false));
  },[id]);

  const handlePrint = () => {
    window.print();
  };

  if(loading) return <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', fontSize:14, color:'#666' }}>Loading invoice...</div>;
  if(!order) return <div style={{ padding:40, textAlign:'center', color:'#666' }}>Order not found.</div>;

  const isQuotation = order.status === 'DRAFT';
  const totalInWords = numToWords(parseFloat(order.total_amount||0));

  return (
    <div>
      {/* Toolbar — hidden on print */}
      <div style={{ background:'#1e3a5f', padding:'12px 24px', display:'flex', justifyContent:'space-between', alignItems:'center' }} className="no-print">
        <div style={{ color:'#fff', fontWeight:600 }}>{isQuotation?'Quotation':'GST Invoice'} — {order.order_number}</div>
        <div style={{ display:'flex', gap:10 }}>
          <button onClick={()=>navigate(`/sales/order/${id}`)} style={{ padding:'7px 16px', background:'rgba(255,255,255,0.15)', color:'#fff', border:'none', borderRadius:6, cursor:'pointer', fontSize:13 }}>← Back</button>
          <button onClick={handlePrint} style={{ padding:'7px 16px', background:'#fff', color:'#1e3a5f', border:'none', borderRadius:6, cursor:'pointer', fontSize:13, fontWeight:600 }}>🖨 Print / Download PDF</button>
        </div>
      </div>

      {/* Invoice */}
      <div ref={printRef} style={{ maxWidth:800, margin:'0 auto', padding:'20px 24px', fontFamily:'Arial, sans-serif', fontSize:12, color:'#000', background:'#fff' }}>
        {/* Header */}
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', borderBottom:'2px solid #1e3a5f', paddingBottom:14, marginBottom:14 }}>
          <div style={{ display:'flex', alignItems:'center', gap:14 }}>
            <img src={`${process.env.PUBLIC_URL}/logo_tyche.png`} alt="Logo" style={{ height:52, width:'auto' }} onError={e=>e.target.style.display='none'}/>
            <div>
              <div style={{ fontSize:16, fontWeight:700, color:'#1e3a5f' }}>{COMPANY.name}</div>
              <div style={{ fontSize:11, color:'#555', marginTop:3, lineHeight:1.5 }}>{COMPANY.address.split('\n').map((l,i)=><span key={i}>{l}<br/></span>)}</div>
              <div style={{ fontSize:11, color:'#555', marginTop:2 }}>GSTIN: <strong>{COMPANY.gstin}</strong> | State: {COMPANY.state} ({COMPANY.stateCode})</div>
            </div>
          </div>
          <div style={{ textAlign:'right' }}>
            <div style={{ fontSize:18, fontWeight:700, color:'#1e3a5f', textTransform:'uppercase' }}>{isQuotation?'QUOTATION':'TAX INVOICE'}</div>
            <table style={{ marginTop:8, fontSize:11, borderCollapse:'collapse', marginLeft:'auto' }}>
              <tbody>
                <tr><td style={{ padding:'2px 8px 2px 0', color:'#555' }}>{isQuotation?'Quotation No.':'Invoice No.'}</td><td style={{ fontWeight:700 }}>{order.order_number}</td></tr>
                <tr><td style={{ padding:'2px 8px 2px 0', color:'#555' }}>Date</td><td style={{ fontWeight:700 }}>{order.order_date}</td></tr>
                {isQuotation&&<tr><td style={{ padding:'2px 8px 2px 0', color:'#555' }}>Valid Until</td><td style={{ fontWeight:700 }}>{order.delivery_date||'—'}</td></tr>}
                {!isQuotation&&order.delivery_date&&<tr><td style={{ padding:'2px 8px 2px 0', color:'#555' }}>Delivery Date</td><td style={{ fontWeight:700 }}>{order.delivery_date}</td></tr>}
              </tbody>
            </table>
          </div>
        </div>

        {/* Bill To / Ship To */}
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:14 }}>
          <div style={{ border:'1px solid #ddd', borderRadius:4, padding:10 }}>
            <div style={{ fontSize:11, fontWeight:700, color:'#1e3a5f', marginBottom:6, textTransform:'uppercase', letterSpacing:'0.5px' }}>Bill To</div>
            <div style={{ fontWeight:700, fontSize:13 }}>{customer?.name}</div>
            {customer?.contact_person&&<div style={{ color:'#555', marginTop:2 }}>Attn: {customer.contact_person}</div>}
            {customer?.address&&<div style={{ color:'#555', marginTop:2, lineHeight:1.5 }}>{customer.address}</div>}
            {(customer?.city||customer?.state)&&<div style={{ color:'#555' }}>{[customer.city,customer.state,customer.pincode].filter(Boolean).join(', ')}</div>}
            {customer?.phone&&<div style={{ color:'#555', marginTop:2 }}>📞 {customer.phone}</div>}
            {customer?.gstin&&<div style={{ marginTop:4, fontWeight:600 }}>GSTIN: {customer.gstin}</div>}
          </div>
          <div style={{ border:'1px solid #ddd', borderRadius:4, padding:10 }}>
            <div style={{ fontSize:11, fontWeight:700, color:'#1e3a5f', marginBottom:6, textTransform:'uppercase', letterSpacing:'0.5px' }}>Ship To</div>
            {order.delivery_address ? (
              <div style={{ color:'#555', lineHeight:1.6 }}>{order.delivery_address}</div>
            ) : (
              <div style={{ color:'#aaa', fontSize:11 }}>Same as billing address</div>
            )}
            {order.dispatch?.vehicle_number&&<div style={{ marginTop:6, color:'#555' }}>Vehicle: <strong>{order.dispatch.vehicle_number}</strong></div>}
            {order.dispatch?.driver_name&&<div style={{ color:'#555' }}>Driver: {order.dispatch.driver_name} {order.dispatch.driver_phone?`(${order.dispatch.driver_phone})`:''}</div>}
            {order.dispatch?.transport_company&&<div style={{ color:'#555' }}>Transport: {order.dispatch.transport_company}</div>}
            {order.dispatch?.lr_number&&<div style={{ color:'#555' }}>LR No: {order.dispatch.lr_number}</div>}
            {order.dispatch?.dispatch_date&&<div style={{ color:'#555' }}>Dispatch Date: {order.dispatch.dispatch_date}</div>}
          </div>
        </div>

        {/* Items Table */}
        <table style={{ width:'100%', borderCollapse:'collapse', marginBottom:14, fontSize:12 }}>
          <thead>
            <tr style={{ background:'#1e3a5f', color:'#fff' }}>
              <th style={{ padding:'8px 10px', textAlign:'left', width:32 }}>#</th>
              <th style={{ padding:'8px 10px', textAlign:'left' }}>Description</th>
              <th style={{ padding:'8px 10px', textAlign:'center', width:60 }}>HSN</th>
              <th style={{ padding:'8px 10px', textAlign:'right', width:70 }}>Qty</th>
              <th style={{ padding:'8px 10px', textAlign:'center', width:50 }}>Unit</th>
              <th style={{ padding:'8px 10px', textAlign:'right', width:90 }}>Unit Price</th>
              <th style={{ padding:'8px 10px', textAlign:'right', width:100 }}>Total</th>
            </tr>
          </thead>
          <tbody>
            {(order.items||[]).map((item,i)=>(
              <tr key={i} style={{ borderBottom:'1px solid #eee', background:i%2===0?'#fafafa':'#fff' }}>
                <td style={{ padding:'8px 10px', color:'#888' }}>{i+1}</td>
                <td style={{ padding:'8px 10px', fontWeight:500 }}>{item.description}</td>
                <td style={{ padding:'8px 10px', textAlign:'center', color:'#888' }}>6802</td>
                <td style={{ padding:'8px 10px', textAlign:'right', fontFamily:'monospace' }}>{item.quantity}</td>
                <td style={{ padding:'8px 10px', textAlign:'center', color:'#888' }}>{item.unit}</td>
                <td style={{ padding:'8px 10px', textAlign:'right', fontFamily:'monospace' }}>{inr(item.unit_price)}</td>
                <td style={{ padding:'8px 10px', textAlign:'right', fontFamily:'monospace', fontWeight:600 }}>{inr(item.total_price)}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Totals + Tax */}
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:14 }}>
          {/* Tax breakdown */}
          <div>
            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:11 }}>
              <thead>
                <tr style={{ background:'#f0f0f0' }}>
                  <th style={{ padding:'6px 8px', textAlign:'left', border:'1px solid #ddd' }}>HSN Code</th>
                  <th style={{ padding:'6px 8px', textAlign:'right', border:'1px solid #ddd' }}>Taxable Value</th>
                  <th style={{ padding:'6px 8px', textAlign:'center', border:'1px solid #ddd' }}>CGST {order.cgst_percent}%</th>
                  <th style={{ padding:'6px 8px', textAlign:'center', border:'1px solid #ddd' }}>SGST {order.sgst_percent}%</th>
                  <th style={{ padding:'6px 8px', textAlign:'right', border:'1px solid #ddd' }}>Total Tax</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ padding:'6px 8px', border:'1px solid #ddd' }}>6802</td>
                  <td style={{ padding:'6px 8px', textAlign:'right', border:'1px solid #ddd', fontFamily:'monospace' }}>{inr(order.taxable_amount)}</td>
                  <td style={{ padding:'6px 8px', textAlign:'right', border:'1px solid #ddd', fontFamily:'monospace' }}>{inr(order.cgst_amount)}</td>
                  <td style={{ padding:'6px 8px', textAlign:'right', border:'1px solid #ddd', fontFamily:'monospace' }}>{inr(order.sgst_amount)}</td>
                  <td style={{ padding:'6px 8px', textAlign:'right', border:'1px solid #ddd', fontFamily:'monospace', fontWeight:600 }}>{inr(parseFloat(order.cgst_amount||0)+parseFloat(order.sgst_amount||0))}</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Amount summary */}
          <div>
            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:12 }}>
              <tbody>
                {[
                  ['Subtotal', inr(order.subtotal)],
                  [`Discount (${order.discount_percent}%)`, `-${inr(order.discount_amount)}`],
                  ['Taxable Amount', inr(order.taxable_amount)],
                  [`CGST @ ${order.cgst_percent}%`, inr(order.cgst_amount)],
                  [`SGST @ ${order.sgst_percent}%`, inr(order.sgst_amount)],
                ].map(([l,v],i)=>(
                  <tr key={i} style={{ borderBottom:'1px solid #eee' }}>
                    <td style={{ padding:'5px 8px', color:'#555' }}>{l}</td>
                    <td style={{ padding:'5px 8px', textAlign:'right', fontFamily:'monospace' }}>{v}</td>
                  </tr>
                ))}
                <tr style={{ background:'#1e3a5f', color:'#fff' }}>
                  <td style={{ padding:'8px', fontWeight:700, fontSize:14 }}>Total Amount</td>
                  <td style={{ padding:'8px', textAlign:'right', fontFamily:'monospace', fontWeight:700, fontSize:14 }}>{inr(order.total_amount)}</td>
                </tr>
                {!isQuotation&&<>
                  <tr style={{ background:'#EAF3DE' }}>
                    <td style={{ padding:'5px 8px', color:'#3B6D11', fontWeight:600 }}>Amount Paid</td>
                    <td style={{ padding:'5px 8px', textAlign:'right', fontFamily:'monospace', color:'#3B6D11', fontWeight:600 }}>{inr(order.paid_amount)}</td>
                  </tr>
                  <tr style={{ background:'#FDE8E8' }}>
                    <td style={{ padding:'5px 8px', color:'#C0392B', fontWeight:700 }}>Balance Due</td>
                    <td style={{ padding:'5px 8px', textAlign:'right', fontFamily:'monospace', color:'#C0392B', fontWeight:700 }}>{inr(order.balance_amount)}</td>
                  </tr>
                </>}
              </tbody>
            </table>
          </div>
        </div>

        {/* Amount in words */}
        <div style={{ border:'1px solid #ddd', borderRadius:4, padding:'8px 12px', marginBottom:14, fontSize:12 }}>
          <span style={{ color:'#555' }}>Total Amount in Words: </span>
          <strong>{totalInWords}</strong>
        </div>

        {/* Payment info */}
        {!isQuotation && order.payments?.length>0 && (
          <div style={{ marginBottom:14 }}>
            <div style={{ fontSize:11, fontWeight:700, color:'#1e3a5f', marginBottom:6, textTransform:'uppercase' }}>Payment Details</div>
            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:11 }}>
              <thead><tr style={{ background:'#f0f0f0' }}><th style={{ padding:'5px 8px', border:'1px solid #ddd', textAlign:'left' }}>Date</th><th style={{ padding:'5px 8px', border:'1px solid #ddd', textAlign:'left' }}>Mode</th><th style={{ padding:'5px 8px', border:'1px solid #ddd', textAlign:'left' }}>Reference</th><th style={{ padding:'5px 8px', border:'1px solid #ddd', textAlign:'right' }}>Amount</th></tr></thead>
              <tbody>
                {order.payments.map((p,i)=>(
                  <tr key={i} style={{ borderBottom:'1px solid #eee' }}>
                    <td style={{ padding:'5px 8px', border:'1px solid #ddd' }}>{p.payment_date}</td>
                    <td style={{ padding:'5px 8px', border:'1px solid #ddd' }}>{p.payment_mode}</td>
                    <td style={{ padding:'5px 8px', border:'1px solid #ddd', color:'#888' }}>{p.reference_number||'—'}</td>
                    <td style={{ padding:'5px 8px', border:'1px solid #ddd', textAlign:'right', fontFamily:'monospace', fontWeight:600, color:'#3B6D11' }}>{inr(p.amount)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Notes */}
        {order.notes&&<div style={{ marginBottom:14, fontSize:11, color:'#555' }}><strong>Notes:</strong> {order.notes}</div>}

        {/* Footer */}
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginTop:20, paddingTop:16, borderTop:'1px solid #ddd' }}>
          <div style={{ fontSize:11, color:'#555' }}>
            <div style={{ fontWeight:700, marginBottom:4 }}>Terms & Conditions</div>
            <div>1. Goods once sold will not be taken back.</div>
            <div>2. Interest @ 24% p.a. will be charged on delayed payments.</div>
            <div>3. Subject to Coimbatore jurisdiction.</div>
            {isQuotation&&<div>4. This quotation is valid for 15 days from the date of issue.</div>}
          </div>
          <div style={{ textAlign:'right' }}>
            <div style={{ fontSize:11, color:'#555', marginBottom:40 }}>For <strong>{COMPANY.name}</strong></div>
            <div style={{ borderTop:'1px solid #999', paddingTop:4, fontSize:11, color:'#555', display:'inline-block', minWidth:150 }}>Authorised Signatory</div>
          </div>
        </div>

        {/* Print footer */}
        <div style={{ marginTop:20, textAlign:'center', fontSize:10, color:'#aaa', borderTop:'1px solid #eee', paddingTop:10 }}>
          This is a computer generated {isQuotation?'quotation':'invoice'}. | TYCHE ABODES PRIVATE LIMITED | GSTIN: {COMPANY.gstin}
        </div>
      </div>

      <style>{`
        @media print {
          .no-print { display: none !important; }
          body { margin: 0; }
        }
      `}</style>
    </div>
  );
}
